import gql from 'graphql-tag';

export const createApplicationMutation = gql`
  mutation ($input: ApplicationCreateInput) {
    createApplication(input: $input)
    {
      applicationId
      name
      remark
      date
      apiKey
      sdkKey
      configuration
    }
  }
`
